var hamburger = document.querySelector('.hamburger');
var menu = document.querySelector('.navigation');
var header = document.querySelector('.header');
var body = document.body;

//Toggle hamburger menu
export function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
    body.classList.remove('search-open');
    document.querySelector('.sooqrSearchContainer').style.display = 'none';
    document.querySelector('#sooqrSearch').value = '';
    document.querySelector('.search button').classList.remove('close');
    document.querySelector('.search button').innerHTML = 'Zoeken';
}
